import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './Form.css'
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
